import React, { memo } from 'react';
import { AlertCircle } from 'lucide-react';
export const PainPoints: React.FC = () => {
  const points = ['¿Tenés miedo de contaminar la mesa o romper la técnica estéril por nervios?', '¿Sentís que la teoría de la facultad no te preparó para la presión real del quirófano?', '¿Te paraliza la idea de que te toque una urgencia y no sepas cómo armar la mesa a tiempo?'];
  return <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 text-center mb-10" data-id="element-122">
          Seamos honestos...{' '}
          <span className="text-red-600" data-id="element-123">¿Te pasa esto?</span>
        </h2>

        <div className="space-y-4" data-id="element-124">
          {points.map((point, index) => <div key={index} className="flex items-start gap-4 p-5 rounded-xl bg-red-50 border border-red-100" data-id="element-125">
              <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-126" />
              <p className="text-slate-800 font-medium text-lg leading-snug" data-id="element-127">
                {point}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-128">
          <p className="text-xl text-slate-600 font-medium" data-id="element-129">
            No es tu culpa. El sistema tradicional te enseña a memorizar, no a
            entender.
          </p>
        </div>
      </div>
    </section>;
};